module.exports = __webpack_public_path__ + "static/media/noa-ignite-black.90e5feb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/noa-ignite-black.svg
// module id = 597
// module chunks = 0